var map = {
	"./building_and_construction.jpeg": 8591,
	"./long_haul.jpeg": 7657,
	"./mining_and_quarry.jpeg": 1557,
	"./regional_haul.jpeg": 6701,
	"./waste_and_recycling.jpeg": 8510
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 2941;